module.exports = __webpack_public_path__ + "img/YM-SWT.928ad68e.png";